export default __webpack_public_path__ + "static/media/login_bg.8bc83e11.png";